import { Routes, Route } from "react-router-dom";
import Order from "./container/Order";
import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import { Suspense } from "react";
import OrderStatus from "./container/OrderStatus";

const App: React.FunctionComponent = () => {
  return (
    <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Order />} />
          <Route path="/order/success" element={<OrderStatus isSuccess={true} />} />
          <Route path="/order/failed" element={<OrderStatus isSuccess={false} />} />
        </Routes>
    </Suspense>
  );
}

export default App;
